<template>
  <div class="courses-wrapper">
    <CoursesBanner />
    <CoursesFilters v-if="filterList.length" :filter-list="filterList" :total="total" @change="handleFilterChange" @update="updateFilterParams" />
    <CoursesModeChange :courses-mode="coursesMode" :loading="loading" @mode-change="handleCoursesModeChange" />
    <template v-if="firstLoading">
      <Loading :show="true" />
    </template>
    <template v-else>
      <template v-if="showErrorStatus">
        <div class="exception-wrapper">
          <Exception
            :tip-text="errorNotice"
            placeholder-class-name="system-error-img"
            class-name="button-grey"
            :show-retry-btn="true"
            :retry-btn-text="$t('common.retry')"
            @retry="handleRetry"
          />
        </div>
      </template>
      <template v-else-if="showEmptyStatus">
        <div class="exception-wrapper">
          <Exception
            :tip-text="emptyNotice"
            placeholder-class-name="no-avalible-data-img"
            class-name="button-outline"
            :show-retry-btn="false"
            @retry="handleRetry"
          />
        </div>
      </template>
      <template v-else>
        <CoursesResults :courses-mode="coursesMode" :loading="loading" :loadend="loadend" :courses-list="coursesList" @load-more="handleLoadMore" />
      </template>
    </template>
  </div>
</template>
<script>
import listMixin from 'mixins/courses/list'
import Exception from 'components/common/Exception'
import CoursesBanner from '@/components/global/FeatureComponents/Courses/CoursesBanner/web'
import CoursesFilters from '@/components/global/FeatureComponents/Courses/CoursesFilters/web'
import CoursesModeChange from '@/components/global/FeatureComponents/Courses/CoursesModeChange/web'
import CoursesResults from '@/components/global/FeatureComponents/Courses/CoursesResults/web'

import Loading from 'components/common/Loading/index.vue'

export default {
  components: {
    Loading,
    Exception,
    CoursesBanner,
    CoursesFilters,
    CoursesModeChange,
    CoursesResults,
  },
  mixins: [listMixin],
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.courses-wrapper {
  padding: 20px 0;
  background: #f5f5f5;
}

.exception-wrapper {
  padding: 100px 0;
}
</style>
